/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Summary_LayoutInputs */

const en_views_summary_layout = /** @type {(inputs: Views_Summary_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

const de_views_summary_layout = /** @type {(inputs: Views_Summary_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darstellung`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Views_Summary_LayoutInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_summary_layout = /** @type {((inputs?: Views_Summary_LayoutInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Summary_LayoutInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_summary_layout(inputs)
	return en_views_summary_layout(inputs)
});